const de = {
  nav: {
    events: 'Veranstaltungen',
    account: 'Meine Tickets',
    admin: 'Verwaltung',
    switchLanguage: 'English',
    switchLanguageLabel: 'Switch to English',
    home: 'Zur Startseite',
  },
  home: {
    eyebrow: 'Absolventenverband Hagenberg',
    title: 'Tickets & Anmeldungen',
    intro: 'Sichern Sie sich Ihre Plätze für unsere Veranstaltungen – bequem online, bezahlt wird per Überweisung.',
    upcoming: 'Kommende Veranstaltungen',
    none: 'Derzeit sind keine Veranstaltungen im Verkauf. Schauen Sie bald wieder vorbei!',
    details: 'Details & Tickets',
    detailsFree: 'Details & Anmeldung',
  },
  event: {
    back: 'Alle Veranstaltungen',
    when: 'Termin',
    doors: 'Einlass',
    where: 'Ort',
    price: 'Preis',
    perTicket: 'pro Ticket',
    free: 'Kostenlos',
    freeSeating: 'Freie Platzwahl',
    available: (count: number) => (count === 1 ? 'Nur noch 1 Platz frei' : `Noch ${count} Plätze frei`),
    soldOut: 'Ausverkauft',
    notStarted: (date: string) => `Verkaufsstart am ${date}`,
    ended: 'Der Verkauf ist beendet',
    buyTitle: 'Tickets bestellen',
    registerTitle: 'Anmelden',
    quantity: 'Anzahl',
    discountCode: 'Ermäßigungscode (optional)',
    applyCode: 'Einlösen',
    removeCode: 'Entfernen',
    codeApplied: (label: string) => `Ermäßigung „${label}“ berücksichtigt`,
    discount: 'Ermäßigung',
    total: 'Gesamt',
    contact: 'Ihre Daten',
    addressHint: 'Die Adresse benötigen wir für die Rechnung.',
    firstName: 'Vorname',
    lastName: 'Nachname',
    email: 'E-Mail',
    phone: 'Telefon',
    street: 'Straße und Hausnummer',
    zip: 'PLZ',
    city: 'Ort',
    country: 'Land',
    acceptPrefix: 'Ich akzeptiere die',
    terms: 'Ticketbedingungen',
    acceptMiddle: 'und habe die',
    privacy: 'Datenschutzerklärung',
    acceptSuffix: 'gelesen.',
    submitOrder: 'Verbindlich bestellen',
    submitRegistration: 'Jetzt anmelden',
    submitting: 'Wird gesendet …',
    paymentInfo:
      'Nach der Bestellung erhalten Sie eine Rechnung mit QR-Code für die Überweisung. Die Tickets kommen per E-Mail, sobald die Zahlung eingelangt ist.',
    freeInfo: 'Nach der Anmeldung erhalten Sie Ihre Bestätigung mit QR-Code sofort per E-Mail.',
  },
  order: {
    title: 'Ihre Bestellung',
    number: 'Bestellnummer',
    status: {
      reserved: 'Reserviert – Zahlung ausständig',
      paid: 'Bezahlt – Tickets versendet',
      cancelled: 'Storniert',
      expired: 'Reservierung verfallen',
    },
    statusFree: 'Anmeldung bestätigt',
    thanks: 'Vielen Dank für Ihre Bestellung!',
    thanksFree: 'Vielen Dank für Ihre Anmeldung!',
    mailSent: (email: string) => `Eine Bestätigung wurde an ${email} gesendet.`,
    payTitle: 'Bitte überweisen Sie',
    payIntro: (due: string) => `Bitte überweisen Sie den Betrag bis ${due}. Ihre Tickets erhalten Sie nach Zahlungseingang per E-Mail.`,
    recipient: 'Empfänger',
    amount: 'Betrag',
    reference: 'Zahlungsreferenz',
    referenceHint: 'Bitte geben Sie unbedingt die Zahlungsreferenz an.',
    scanHint: 'Zahlen mit Code: QR-Code mit der Banking-App scannen',
    copy: 'Kopieren',
    copied: 'Kopiert',
    downloadInvoice: 'Rechnung (PDF)',
    downloadTickets: 'Tickets herunterladen (PDF)',
    paidInfo: 'Ihre Zahlung ist eingelangt. Bitte drucken Sie die Tickets aus oder zeigen Sie sie am Smartphone vor.',
    cancelledInfo: 'Diese Bestellung wurde storniert. Ausgestellte Tickets sind ungültig.',
    expiredInfo: 'Die Zahlungsfrist ist abgelaufen und die Plätze wurden freigegeben. Bitte kontaktieren Sie uns, falls Sie bereits bezahlt haben.',
    saveLink: 'Speichern Sie diesen Link – Sie können Ihre Bestellung und Tickets jederzeit darüber abrufen.',
    summary: 'Übersicht',
    tickets: 'Tickets',
  },
  account: {
    title: 'Meine Tickets',
    intro: 'Melden Sie sich mit Ihrer E-Mail-Adresse an, um alle Ihre Bestellungen und Tickets zu sehen. Ein Konto ist für den Kauf nicht nötig.',
    none: 'Zu dieser E-Mail-Adresse gibt es noch keine Bestellungen.',
    open: 'Öffnen',
    signedInAs: (email: string) => `Angemeldet als ${email}`,
    signOut: 'Abmelden',
  },
  login: {
    email: 'E-Mail-Adresse',
    sendCode: 'Code anfordern',
    codeSent: (email: string) => `Wir haben einen 6-stelligen Code an ${email} geschickt.`,
    code: 'Code aus der E-Mail',
    verify: 'Anmelden',
    otherEmail: 'Andere E-Mail-Adresse',
  },
  footer: {
    imprint: 'Impressum',
    privacy: 'Datenschutz',
    terms: 'Ticketbedingungen',
    contact: 'Kontakt',
  },
  common: {
    loading: 'Wird geladen …',
    error: 'Da ist etwas schiefgelaufen.',
    retry: 'Erneut versuchen',
    notFound: 'Seite nicht gefunden',
  },
};

export type Messages = typeof de;

const en: Messages = {
  nav: {
    events: 'Events',
    account: 'My tickets',
    admin: 'Admin',
    switchLanguage: 'Deutsch',
    switchLanguageLabel: 'Auf Deutsch wechseln',
    home: 'Home',
  },
  home: {
    eyebrow: 'Hagenberg Alumni Association',
    title: 'Tickets & registration',
    intro: 'Get your seats for our events online – payment by bank transfer.',
    upcoming: 'Upcoming events',
    none: 'There are currently no events on sale. Please check back soon!',
    details: 'Details & tickets',
    detailsFree: 'Details & registration',
  },
  event: {
    back: 'All events',
    when: 'Date',
    doors: 'Doors open',
    where: 'Venue',
    price: 'Price',
    perTicket: 'per ticket',
    free: 'Free',
    freeSeating: 'Unreserved seating',
    available: (count: number) => (count === 1 ? 'Only 1 seat left' : `${count} seats left`),
    soldOut: 'Sold out',
    notStarted: (date: string) => `Sales start on ${date}`,
    ended: 'Sales have ended',
    buyTitle: 'Order tickets',
    registerTitle: 'Register',
    quantity: 'Quantity',
    discountCode: 'Discount code (optional)',
    applyCode: 'Apply',
    removeCode: 'Remove',
    codeApplied: (label: string) => `Discount "${label}" applied`,
    discount: 'Discount',
    total: 'Total',
    contact: 'Your details',
    addressHint: 'We need your address for the invoice.',
    firstName: 'First name',
    lastName: 'Last name',
    email: 'E-mail',
    phone: 'Phone',
    street: 'Street and number',
    zip: 'Postcode',
    city: 'City',
    country: 'Country',
    acceptPrefix: 'I accept the',
    terms: 'ticket terms',
    acceptMiddle: 'and have read the',
    privacy: 'privacy policy',
    acceptSuffix: '.',
    submitOrder: 'Place binding order',
    submitRegistration: 'Register now',
    submitting: 'Sending …',
    paymentInfo:
      'After ordering you will receive an invoice with a QR code for the bank transfer. Your tickets are e-mailed as soon as the payment has arrived.',
    freeInfo: 'You will receive your confirmation with QR code by e-mail right after registering.',
  },
  order: {
    title: 'Your order',
    number: 'Order number',
    status: {
      reserved: 'Reserved – awaiting payment',
      paid: 'Paid – tickets sent',
      cancelled: 'Cancelled',
      expired: 'Reservation expired',
    },
    statusFree: 'Registration confirmed',
    thanks: 'Thank you for your order!',
    thanksFree: 'Thank you for registering!',
    mailSent: (email: string) => `A confirmation has been sent to ${email}.`,
    payTitle: 'Please transfer',
    payIntro: (due: string) => `Please transfer the amount by ${due}. Your tickets will be e-mailed to you once the payment has arrived.`,
    recipient: 'Recipient',
    amount: 'Amount',
    reference: 'Payment reference',
    referenceHint: 'Please make sure to include the payment reference.',
    scanHint: 'Scan the QR code with your banking app to pay',
    copy: 'Copy',
    copied: 'Copied',
    downloadInvoice: 'Invoice (PDF)',
    downloadTickets: 'Download tickets (PDF)',
    paidInfo: 'Your payment has arrived. Please print your tickets or show them on your smartphone.',
    cancelledInfo: 'This order has been cancelled. Any tickets issued are no longer valid.',
    expiredInfo: 'The payment period has expired and the seats were released. Please contact us if you have already paid.',
    saveLink: 'Keep this link – you can use it to access your order and tickets at any time.',
    summary: 'Summary',
    tickets: 'Tickets',
  },
  account: {
    title: 'My tickets',
    intro: 'Log in with your e-mail address to see all your orders and tickets. No account is needed to buy tickets.',
    none: 'There are no orders for this e-mail address yet.',
    open: 'Open',
    signedInAs: (email: string) => `Logged in as ${email}`,
    signOut: 'Log out',
  },
  login: {
    email: 'E-mail address',
    sendCode: 'Send code',
    codeSent: (email: string) => `We have sent a 6-digit code to ${email}.`,
    code: 'Code from the e-mail',
    verify: 'Log in',
    otherEmail: 'Use a different e-mail address',
  },
  footer: {
    imprint: 'Legal notice',
    privacy: 'Privacy',
    terms: 'Ticket terms',
    contact: 'Contact',
  },
  common: {
    loading: 'Loading …',
    error: 'Something went wrong.',
    retry: 'Try again',
    notFound: 'Page not found',
  },
};

export const MESSAGES = { de, en };
